import React from "react";
import PropTypes from "prop-types";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";

import CreatePolicyDialog from "../containers/CreatePolicyDialog";

const CreatePolicyFab = ({ className }) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Fab color="secondary" className={className} onClick={handleOpen}>
        <AddIcon />
      </Fab>
      <CreatePolicyDialog open={open} handleClose={handleClose} />
    </>
  );
};

CreatePolicyFab.propTypes = {
  className: PropTypes.string,
};

export default CreatePolicyFab;
